import { Component, AfterContentInit, ViewChild, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { formPlycaComponent } from '../components/forms/formPlyca.component';
import { FormConfig } from '../components/forms/form.objects';
import { PlycaDataService } from '../../services/plyca.service';
import { Configuration } from '../conf/app.constants';
import { UIService, generateRandomIdentifier } from '../ui.service';
import { ReportDTO, ValidationExecutionDTO, ReportProfileDTO, HelpInterface } from '../api/plyca-dtos-v2';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { SelectItem } from 'primeng-lts/api';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { finalize } from 'rxjs/operators';

export class ReportConfDTOModal extends HelpInterface {
  public report: ReportDTO;
  constructor(report: ReportDTO) {
    super();
    this.report = report;
  }
}

@Component({
  selector: 'reports-conf',
  templateUrl: 'reports-conf.template.html'
})
export class ReportsConfComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  report: ReportDTO;
  formConfig: FormConfig;
  @ViewChild('frmReport') frmAward: formPlycaComponent;
  showHeader = true;
  loading = true;
  loadingProfiles = true;
  profilesModel: SelectItem[];
  editMode = false;
  tagsParent: string[] = [];
  windowHash: string;

  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public uiService: UIService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    private waitService: WaitLoadingService,
    private el: ElementRef
  ) {
    super();
    if (dialogConfig['context'] !== undefined) {
      this.report = dialogConfig['context'].report;
      this.tagsParent = dialogConfig['context'].tags;
      if (this.report !== undefined) {
        this.editMode = true;
      }
    }

    this.subscribe(this.helpService.showContextHelpObservable(HelpType.REPORT_CONF_INFORME));
  }
  ngOnInit(): void {
    this.waitService.startWaiting();
  }

  ngAfterContentInit(): void {

    this.windowHash = generateRandomIdentifier();


    this.loadActions();


    if (this.report == null || this.report === undefined) {
      this.report = new ReportDTO();
    }
    this.loadProfiles();
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 500);
  }

  loadActions() {

    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-times',
      'btn btn-secondary',
      true, this.windowHash
    ),
      success => {
        this.close();
      });

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.accept',
      'fa fa-check',
      'btn btn-primary',
      true, this.windowHash
    ),
      success => {
        this.registerReport(this.report);
      });

  }

  loadProfiles() {
    this.subscribe(
      this.plycaService.query<any>(this.configuration.PROFILES_SERVICE_URL + '')
        .pipe(finalize(() => this.waitService.cancelWaiting())),
      resp => {
        if (resp && resp.content) {
          this.report.allProfiles = resp.content;
          if (this.report.allProfiles !== undefined) {
            this.profilesModel = this.report.allProfiles.map(profile => {
              return { label: profile.description, value: profile };
            });
          }
        } else {
          this.report.allProfiles = [];
        }
        this.loadReport();
      });
    this.loadingProfiles = false;
  }

  loadReport() {
    if (this.editMode) {
      this.report.allProfilesSelected = [];
      if (this.report.profiles !== undefined) {
        this.report.profiles.forEach(reportprofile => {
          let profileFilter = this.report.allProfiles.filter(profile => profile.identifier === reportprofile.profile.identifier);
          let profileSelected = profileFilter[0];
          this.report.allProfilesSelected.push(profileSelected);
        });
      }
    }
    this.formConfig = new FormConfig(undefined,
      'reportInterfaceSettings.json',
      this.report
    );
    this.loading = false;
  }

  isLoading() {
    return this.loading;
  }

  isLoadingProfiles() {
    return this.loadingProfiles;
  }

  close() {
    this.ref.close(this.report);
  }

  ngOnDestroy() {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);
      })));

  }

  registerReport(report: ReportDTO) {
    this.waitService.startWaiting();
    report.profiles = [];
    if (this.report.allProfilesSelected !== undefined) {
      this.report.allProfilesSelected.forEach(profile => {
        let reportProfile = new ReportProfileDTO();
        reportProfile.profile = profile;
        report.profiles.push(reportProfile);
      });
    }
    if (this.editMode) {
      this.subscribe(this.plycaService.update<ReportDTO>(this.configuration.REPORTS_SERVICE_URL, report)
        .pipe(finalize(() => this.waitService.cancelWaiting())),
        reponse => {
          console.log('REPORT UPDATED', reponse);
          this.ref.close(reponse);

        },
        error => {
          console.log('UPDATE REPORT ERROR', error);
          if (error.errors) {
            let errores: Array<ValidationExecutionDTO> = error.errors;
            let strMessage = '';
            errores.forEach((err: ValidationExecutionDTO) => {
              strMessage += err.message + '</br>';
            });
            this.uiService
              .showMessage(strMessage);
          } else {
            this.plycaErrorHandler.showServerError(error);
          }
        }
      );
    } else {
      this.subscribe(this.plycaService.insert<ReportDTO>(this.configuration.REPORTS_SERVICE_URL, report)
        .pipe(finalize(() => this.waitService.cancelWaiting())),
        reponse => {
          console.log('REPORT INSERTADO', reponse);
          this.ref.close(reponse);

        },
        error => {
          console.log('INSERT REPORT ERROR', error);
          this.plycaErrorHandler.showServerError(error);
          // if (error.errors) {
          //   let errores: Array<ValidationExecutionDTO> = error.errors;
          //   let strMessage: string = '';
          //   errores.forEach((err: ValidationExecutionDTO) => {
          //     strMessage += err.message + '</br>';
          //   });
          //   this.uiService
          //     .showMessage(strMessage);
          // }
        }
      );
    }
  }

}
